<div class="flex flex-col bg-navy-900 h-full">
  <div class="p-8">
    <!-- <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      @for (stat of stats; track stat.label) {
        <app-stat-card [stat]="stat" />
      }
    </div> -->
  </div>
  <div class="flex-1 rounded-tl-2xl bg-white p-8">
    <app-recent-incidents
      [incidents]="recentIncidents()"
      [loading]="recentLoading()"
      (viewAll)="onViewAll()"
    />
    <!-- <div class="grid grid-cols-1 md:grid-cols-[7fr_3fr] gap-4 h-full">
      <app-stage-donut-chart [data]="stageData" [total]="42" />
    </div> -->
  </div>
</div>
